<script lang="ts">
import { defineComponent, reactive } from 'vue'
import SolutionPageWrapper from '@/components/solutions/SolutionPageWrapper.vue'
import SymbolicSolutionContentSection from '@/components/solutions/SymbolicSolutionContentSection.vue'
import ExternalHtmlWrapper from '@/components/_core/ExternalHtmlWrapper.vue'
import stateInitializer from '@/models/stateInitializer'
import { solutionPath } from '@/generated/railsRoutes'

export default defineComponent({
  name: 'SolutionIndexMain',

  components: {
    SolutionPageWrapper,
    SymbolicSolutionContentSection,
    ExternalHtmlWrapper,
  },

  setup() {
    interface State {
      solution: Solution,
      document?: SolutionContentItem,
      video?: SolutionContentItem,
      tab: {
        hasDocuments: boolean,
        hasVideos: boolean,
      },
    }

    const state: State = reactive({
      solution: {
        id: undefined,
        title: '',
        detail: '',
      },

      document: {
        id: undefined,
        title: '',
        thumbImageUrl: '',
        description: '',
        to: '',
      },

      video: {
        id: undefined,
        title: '',
        thumbImageUrl: '',
        description: '',
        to: '',
      },

      tab: {
        hasDocuments: false,
        hasVideos: false,
      },
    })

    stateInitializer(state, 'main')

    return {
      // routes
      solutionPath,

      // data
      state,
    }
  },
})
</script>

<template>
  <SolutionPageWrapper
    :id="state.solution.id"
    current-tab-key="index"
    :tab-option="state.tab">
    <template #description>
      <SymbolicSolutionContentSection
        v-if="state.document?.id && state.solution.id"
        :item="state.document"
        header="資料"
        :to="state.tab.hasDocuments ? `${solutionPath({ id: state.solution.id })}/documents` : ''" />

      <SymbolicSolutionContentSection
        v-if="state.video?.id && state.solution.id"
        :item="state.video"
        header="動画"
        :to="state.tab.hasVideos ? `${solutionPath({ id: state.solution.id })}/videos` : ''" />

      <ExternalHtmlWrapper
        v-if="state.solution.detail"
        :contents-html="state.solution.detail" />
    </template>
  </SolutionPageWrapper>
</template>
